import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'overview',
    component: () => import('../views/Overview.vue')
  },

  {
    path: '/xrplnft',
    name: 'xrplnft',
    component: () => import('../views/XrplNft.vue')
  },
  {
    path: '/xrplnftmint',
    name: 'xrplnftmint',
    component: () => import('../views/XrplNftMint.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/Privacy.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('../views/Terms.vue')
  },
  {
    path: '/xummverificationwaiting',
    name: 'xummverificationwaiting',
    component: () => import('../views/XummVerificationWaiting.vue')
  },
  {
    path: '/specifications',
    name: 'specifications',
    component: () => import('../views/Specification.vue')
  },
  {
    path: '*',
    component: () => import('../views/Overview.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
